import React from "react";
import { Card, CardContent } from "@mui/material";
import { MetricsProps } from "./MetricCard.types";
import MetricInfo from "./MetricInfo";

function MetricCard({ metric }: MetricsProps) {
  return (
    <Card
      sx={(theme) => ({
        borderRadius: 2,
        boxShadow: "none",
        position: "relative",
        p: 5,
        border: `0.5px solid ${theme.palette.grey[40]}`,
      })}
    >
      <CardContent
        sx={{
          p: "0 !important",
        }}
      >
        <MetricInfo data={metric} />
      </CardContent>
    </Card>
  );
}

export default MetricCard;
